export const greetings = [
  'Novidade nesta edição: rankings de rentabilidade.',
  'Além dos critérios tradicionais, o Anuário Uqbar 2026 traz rankings inéditos de rentabilidade, o critério que o mercado sempre quis ver, agora com dados.',
];
